export const composeTwo = (f) => (g) => (x) => f(g(x));
